import { useEffect, useRef } from "react"
import { getLiveSocket } from "./liveSocket"

export function useDeviceLive(onEvent) {
  const handlerRef = useRef(onEvent)
  handlerRef.current = onEvent

  useEffect(() => {
    const socket = getLiveSocket()
    if (!socket) return undefined
    const listener = (payload) => {
      if (payload && handlerRef.current) handlerRef.current(payload)
    }
    socket.on("device-live", listener)
    return () => socket.off("device-live", listener)
  }, [])
}
